import {
  makeStyles as muiMakeStyles,
  withStyles as muiWithStyles,
  type Theme,
} from "@material-ui/core";
import type {
  Styles,
  WithStylesOptions,
} from "@material-ui/core/styles/withStyles";

/**
 * @deprecated Use `styled` or `makeStyles` from mui core directly.
 */
export function makeStyles<
  Props extends object = {},
  ClassKey extends string = string,
>(
  styles: Styles<Theme, Props, ClassKey>,
  options?: Omit<WithStylesOptions, "withTheme">,
) {
  // @ts-expect-error: Legacy reason migrating off this function
  return muiMakeStyles<Theme, Props, ClassKey>(styles, options);
}

/**
 * @deprecated Use `styled` or `withStyles` from mui core directly.
 */
export function withStyles<
  ClassKey extends string,
  Options extends WithStylesOptions = {},
  Props extends object = {},
>(
  styles: Styles<Theme, Props, ClassKey>,
  options?: Options,
): ReturnType<typeof muiWithStyles> {
  // @ts-expect-error: Legacy reason migrating off this function
  return muiWithStyles(styles, options);
}
